import { LayoutState } from '~/src/stores/layout'
import LayoutServiceInterface from '~/src/utils/layout/LayoutServiceInterface'

export default class LayoutNotFoundServiceStyleTwo implements LayoutServiceInterface {
  public getLayout(): Partial<LayoutState> {
    return {
      header: {
        display: true,
        displayMenuBurger: false,
        displayCart: false,
        displayCurrentFirm: true,
        displayDeliveryOptions: false,
        displayUserActions: false,
        displayLanguagesSelector: false,
        displayProductSearch: false,
        displayLocationSearch: false,
        logo: {
          disableLink: false
        },
        title: '',
        type: 'navigation'
      },
      subHeader: {
        display: false,
        variant: 'default'
      },
      content: {
        displayNotification: false
      },
      mainSideBar: {
        display: false,
        displayCart: false,
        displayDeliveryOptions: false,
        displayOrderSummary: false
      },
      footer: {
        display: false,
        displayGoToCheckoutBtn: false,
        displayGoToCartBtn: false,
        displayInformations: false,
        displayLinks: false
      },
      mobileNavigation: {
        display: true
      }
    }
  }
}
